<template>
  <LLButton tertiary-dark small :loading="loading" class="ForumResponseSaveButton" @click="onToggleSave">
    <template #icon-left>
      <SavedPostsFilledIcon v-if="isSaved" class="ForumResponseSaveButton__icon" />
      <SavedPostsIcon v-else />
    </template>
  </LLButton>
</template>

<script>
import LLButton from '@/components/common/ui-components/LLButton.vue'
import SavedPostsIcon from '@/assets/icons/SavedPostsIcon.vue'
import SavedPostsFilledIcon from '@/assets/icons/SavedPostsFilledIcon.vue'

export default {
  name: 'ForumResponseSaveButton',
  components: { SavedPostsFilledIcon, SavedPostsIcon, LLButton },
  props: {
    chatId: { type: [Number, String], required: true },
    threadId: { type: String, required: true },
    responseId: { type: String, required: true },
    isSaved: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async onToggleSave() {
      if (this.disabled || this.loading) return
      this.loading = true
      try {
        const { saved } = await this.$api.forum.responses.toggleSave({
          chatId: this.chatId,
          threadId: this.threadId,
          responseId: this.responseId
        })
        this.$emit('toggleSave', { saved })
      } catch (e) {
        // silently fail
      }
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.ForumResponseSaveButton {
  &__icon {
    @apply text-primary-01;
  }
}
</style>
